module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABDUlEQVQ4jd2TMW6DQBBFH+vdAg1QOA1tTuRcwKJGHIG4st3T0LizEH18Kzdx4RVCwgKliMFCcnCcMr/anZ15mr+acQCKolhUVfUOvAAd01LAp4hslsvlwdnv94u6rj8eFN2ViLypuq5XfykGqKpqpYF5H7DWcrlcbr0qRRAEKKV+Ysw1V8/WWuI4RkRGGdvtltlshuM4AGit8Tyvf+50f2rbFhEhSRJEBGstWZaRpukIeDweKctygAyArvv+/DzPJ32HYUjTNDebk9m/0H8CGGM4n88PC6y1GGOGu+4hvu+z2+1Gg3RPxhh83x8a0MAJeO0hT+qkXNdd91P2rERk7QBcN/KpdXZddxNF0eELyfhUxDkoad4AAAAASUVORK5CYII="


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/fav-open.png
 ** module id = 269
 ** module chunks = 0 1
 **/